module.exports = __webpack_public_path__ + "img/icon_prev.99c04c37.svg";